<template id="q-app">
  <router-view />
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useQuasar } from 'quasar';

export default defineComponent({
  name: 'WorldRugbyAdmin',
  setup() {
    const $q = useQuasar();

    $q.iconMapFn = (iconName) => {
      if (iconName.startsWith('wr-')) {
        // Strip 'wr-' and change to SCREAMING_SNAKE_CASE
        const name = iconName.substring(3).replace(/-/g, '_').toUpperCase();

        // Assemble icon string
        return {
          icon: `svguse:/icons/wr-icons/WR_IC_${name}_WHITE_R_NEG.svg#ARTWORK|0 0 120 120`,
        };
      }
      // WR_IC_ASSESSMENT_HEAD_INJURY_WHITE_R_NEG
      // WR_IC_ASSESSMENT_HEAD_INJURY_WHITE_R_NEG
      // returning nothing continues with default behaviour
    };
  },
});
</script>
